
import React from "react";
import { Schemes } from "../../../../utils";
import { i18nManager } from "../../../../i18n";
import { Elements } from "../../../shared/Elements";
import { Siren } from "../../../shared/ConfirmDialog";
import { BaseService, IMember, MemberService, SanitizedResponse } from "../../../../services";
import { Button, ButtonManageRef, FormControl, FormGroup, Subscriber, TextInput, useSubscription } from "@rivtn/noseur";

export interface SocialAccountsProps {
    profile: IMember;
}

function SocialAccounts(props: SocialAccountsProps) {

    const memberService = MemberService.getInstance();
    const saveButtonManageRef = React.useRef<ButtonManageRef>(null);
    const [profile, setProfile] = React.useState<IMember>(props.profile);
    const labels = i18nManager.Labels.account.manage_account.social_accounts;
    const reportNewUpdateProfile = useSubscription("OMNEHOST.PROFILE.UPDATED");

    return (<div className="account-setting">
        <div className="header">
            <span className="title">{i18nManager.Labels.account.manage_account.title} - {labels.title}</span>
            <span className="desc">{labels.desc}</span>
        </div>
        <div className="interests-ai">
            <FormGroup scheme={Schemes.OMNEHOST} className="form" style={{ marginTop: 20 }}>
                {Object.keys(labels.accounts_keys).map((accounts_key: string) => (<FormControl key={accounts_key} isFieldset fill style={{ maxWidth: 600 }}
                    label={(labels.accounts_keys as any)[accounts_key]}>
                    <TextInput defaultValue={profile.social_accounts?.[accounts_key]}
                        onInputComplete={(value) => profile.social_accounts[accounts_key] = value} />
                </FormControl>))}
                <Button raised manageRef={saveButtonManageRef} loadingProps={Elements.BUTTON_LOADING_PROPS} text={i18nManager.Labels.common.save} style={{ padding: "10px 40px" }}
                    onClick={updateSocialAccounts} />
            </FormGroup>
        </div>
    </div>);

    function updateSocialAccounts() {
        saveButtonManageRef.current?.setLoadingState(true);
        memberService.updateSocialAccounts(profile.social_accounts).then(({ sanitized }: SanitizedResponse<IMember>) => {
            setProfile(sanitized);
            reportNewUpdateProfile(sanitized);
            Siren.alert(labels.update_success);
        }).catch(BaseService.reportError).finally(() => saveButtonManageRef.current?.setLoadingState(false));
    }

}

export default SocialAccounts;
